import { render, staticRenderFns } from "./EditLoadOrder.vue?vue&type=template&id=47524c85"
import script from "./EditLoadOrder.vue?vue&type=script&lang=js"
export * from "./EditLoadOrder.vue?vue&type=script&lang=js"
import style0 from "./EditLoadOrder.vue?vue&type=style&index=0&id=47524c85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports